"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLUGINS_LIMIT = void 0;
exports.PLUGINS_LIMIT = {
    lite: 1,
    plus_v2: 3,
    /** @deprecated */ pro: 3,
    pro_v2: 5,
    /** @deprecated */ premium: Infinity,
    premium_v2: 10,
    /** @deprecated */ ultimate: Infinity,
    ultimate_v2: Infinity,
};
//# sourceMappingURL=plugins.js.map